import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { uploadCompleteApi } from "./resourceAPI";

export const uploadComplete = createAsyncThunk(
  "file/upload-complete",
  async ({ resourceId, type, size }, { rejectWithValue }) => {
    try {
      return await uploadCompleteApi(resourceId, type, size);
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to mark uploadComplete complete",
      );
    }
  },
);

const resourceSlice = createSlice({
  name: "resource",
  initialState: {
    resource: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(uploadComplete.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadComplete.fulfilled, (state, action) => {
        state.uploadComplete = action.payload;
        state.loading = false;
      })
      .addCase(uploadComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default resourceSlice.reducer;
